import * as React from 'react';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import * as moment from 'moment';
import * as queryString from 'query-string';
import {
  Title,
  IconButton,
  ButtonGroup,
  Calendar,
  RouteWrapper,
  Hero,
  Section,
  Async,
  HeadingSection,
} from '../../components';
import { getMonth } from '../../redux/actions/history';
import API from '../../redux/api';

interface Props {
  dispatch: Function;
  match: any;
}

interface State {
  ready: boolean;
  year: number;
  month: number;
  history: {
    bookings: { start: any; end: any; status: string }[];
    reservations: { start: any; end: any }[];
    holidays: { name: string; start: any; end: any }[];
  };
}

class Route extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      ready: false,
      year: 0,
      month: 0,
      history: {
        bookings: [],
        reservations: [],
        holidays: [],
      },
    };
    this.getMonth = this.getMonth.bind(this);
  }

  async componentDidMount() {
    const now = moment(this.props.match.params.period).toDate() || new Date();
    if (!this.props.match.params.period) {
      this.props.dispatch(
        replace(`/history/${moment(now).format('YYYY-MM-01')}`),
      );
    }
    this.getMonth(now.getFullYear(), now.getMonth());
  }

  /**
   * Get the month's data for the history calendar
   */
  async getMonth(year: number, month: number) {
    const date = `${year}-${String(month + 1).padStart(2, '0')}-01`;
    const response = await API.request(
      `/history?${queryString.stringify({ date })}`,
    );
    this.setState({
      year,
      month,
      history: (await response.json()).data,
      ready: true,
    });
    this.props.dispatch(replace(`/history/${date}`));
  }

  render() {
    return (
      <RouteWrapper
        title="History"
        requirePermission="MANAGE_BOOKINGS"
        requireAuth
      >
        <Hero className="is-small">
          <div className="level">
            <div className="level-left">
              <div className="level-item">
                <div>
                  History for
                  <Title>
                    <Async on={this.state.ready}>
                      {moment.months(this.state.month)} {this.state.year}
                    </Async>
                  </Title>
                </div>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <ButtonGroup>
                  <IconButton
                    icon="chevron-left"
                    className="is-default"
                    handleClick={() => {
                      let newMonth = this.state.month - 1;
                      let newYear = this.state.year;
                      if (newMonth < 0) {
                        newMonth = 11;
                        newYear -= 1;
                      }
                      this.setState({ ready: false }, async () => {
                        await this.getMonth(newYear, newMonth);
                      });
                    }}
                  >
                    Prev Month
                  </IconButton>
                  <IconButton
                    icon="chevron-right"
                    className="is-default"
                    isRight
                    handleClick={() => {
                      let newMonth = this.state.month + 1;
                      let newYear = this.state.year;
                      if (newMonth > 11) {
                        newMonth = 0;
                        newYear += 1;
                      }
                      this.setState({ ready: false }, async () => {
                        await this.getMonth(newYear, newMonth);
                      });
                    }}
                  >
                    Next Month
                  </IconButton>
                </ButtonGroup>
              </div>
            </div>
          </div>
        </Hero>
        <Section>
          <Calendar
            year={this.state.year}
            month={this.state.month}
            bookings={this.state.history.bookings}
            holidays={this.state.history.holidays}
            reservations={this.state.history.reservations}
            handleClick={(date) => {
              this.props.dispatch(
                push(
                  `/history/${date.format('YYYY-MM-01')}/${date.format(
                    'YYYY-MM-DD',
                  )}`,
                ),
              );
            }}
            ready={this.state.ready}
          />
        </Section>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({ history }) => ({
  history,
});

export default connect(mapStateToProps)(Route);
